import(/* webpackMode: "eager" */ "/root/job_portal/frontend-v5/node_modules/next/dist/client/link.js");
